angular.module('picmonicng').directive('learnNextFact', [
  '$filter',
  'LearnService',
  function ($filter, LearnService) {
    return {
      restrict: 'E',
      link: function (scope, element) {
        scope.start = function () {
          LearnService.nextFact();
        };

        scope.nextStep = function () {
          LearnService.nextFactStep();
        };

        scope.quizAnswer = function (answer) {
          LearnService.quizAnswer(answer);
          LearnService.nextFact();
        };
      },
      templateUrl: '/templates/directives/learn-next-fact.html',
    };
  },
]);
